import STATUS_CODES from 'constants/statusCodes';
import {
	getOfferRefreshV4SummaryArray,
	normalizeVehiclesWithOfferRefreshV4,
} from 'services/marketplace/buyside/offerRefreshV4';
import BuyerOffersService from 'services/marketplace/buyside/offers.service';
import { setNewBidSalesArray } from 'store/slices/offerSummary/buyerOfferSummary';

export const getRefreshDataForVehicleIds = async ({
	vehicles: vehiclesToRefresh,
	searchListKey,
	isFeaturedVehicleCampaign,
	includeSummary,
	isVdp,
	offerSummaryWasLoaded,
	dispatch,
	offerSummarySaleType,
	cancelToken,
	isBuyerNewOfferPayloadStructEnabled = false,
}) => {
	const shouldIncludeSummary = includeSummary && !offerSummaryWasLoaded;
	if (!vehiclesToRefresh.length && !shouldIncludeSummary) return [];

	const offerRefreshService =
		isBuyerNewOfferPayloadStructEnabled ?
			BuyerOffersService.instance.offerRefreshV4
		:	BuyerOffersService.instance.offerRefresh;
	const offerRefreshResult = await offerRefreshService({
		vehicles: vehiclesToRefresh,
		...(isVdp ?
			{ isVdp: true }
		:	{
				focussedSearchListKey: searchListKey,
				isFeaturedVehicleCampaign,
				includeSummary,
				offerSummarySaleType,
			}),
		reason: 'first_load',
		forceRefresh: true,
		cancelToken,
	});

	const isSuccessResponse =
		isBuyerNewOfferPayloadStructEnabled ?
			offerRefreshResult?.status === STATUS_CODES.OK
		:	offerRefreshResult?.status === STATUS_CODES.OK && Boolean(offerRefreshResult?.data?.success);

	if (!isSuccessResponse) {
		throw new Error('Not able to get refreshed data for vehicles');
	}

	if (isBuyerNewOfferPayloadStructEnabled) {
		const summary = getOfferRefreshV4SummaryArray(offerRefreshResult?.data);
		if (includeSummary && dispatch) dispatch(setNewBidSalesArray({ bidSalesArr: summary || [] }));

		return normalizeVehiclesWithOfferRefreshV4({
			vehicles: vehiclesToRefresh,
			responsePayload: offerRefreshResult?.data,
		});
	}

	const {
		data: {
			data: { vehicles, summary },
		},
	} = offerRefreshResult;

	if (includeSummary && dispatch) dispatch(setNewBidSalesArray({ bidSalesArr: summary || [] }));

	const bidSaleIdToVehicleMap = vehicles.reduce(
		(accumulator, currentValue) => ({
			...accumulator,
			[currentValue.bid_sale_id]: currentValue,
		}),
		{},
	);

	return vehiclesToRefresh.map((vehicle) => ({
		...vehicle,
		...bidSaleIdToVehicleMap[vehicle.bid_sale_id],
	}));
};
